import { render } from "./SchemaSolutionChangeList.vue?vue&type=template&id=b513695a&scoped=true"
import script from "./SchemaSolutionChangeList.vue?vue&type=script&lang=js"
export * from "./SchemaSolutionChangeList.vue?vue&type=script&lang=js"

import "./SchemaSolutionChangeList.vue?vue&type=style&index=0&id=b513695a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b513695a"]])

export default __exports__